import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import Slide from "../Atomics/Slide/Slide";
import { useEffect, useRef, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faAngleLeft,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { SidebarContext } from "../../context/sidebar";

export default function TopCategoriesSlider({ tenChannels, title, type }) {
  const sliderRef = useRef(null);
  const [sliderInstance, setSliderInstance] = useState(null);
  const { showMenu } = useContext(SidebarContext);

  const [ref, slider] = useKeenSlider({
    loop: true,
    mode: "snap",
    slides: {
      perView: tenChannels?.length <= 9 ? tenChannels.length : 9,
      spacing: 15,
    },
    breakpoints: {
      "(max-width: 1200px)": {
        slides: { perView: 8, spacing: 10 },
      },
      "(max-width: 1000px)": {
        slides: { perView: 3, spacing: 10 },
      },
      "(max-width: 600px)": {
        slides: { perView: 1, spacing: 10 },
      },
    },
    created(s) {
      setSliderInstance(s);
    },
  });

  // Auto-advance slider
  useEffect(() => {
    const interval = setInterval(() => {
      sliderInstance?.next();
    }, 2000);
    return () => clearInterval(interval);
  }, [sliderInstance]);

  // Watch for sidebar toggle and update slider
  useEffect(() => {
    if (!sliderInstance || !ref.current) return;

    // Use ResizeObserver to detect container width changes
    const resizeObserver = new ResizeObserver(() => {
      sliderInstance.update();
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [sliderInstance, ref]);

  // Update slider when sidebar state changes
  useEffect(() => {
    if (sliderInstance) {
      // Small delay to allow CSS transition to complete
      const timer = setTimeout(() => {
        sliderInstance.update();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showMenu, sliderInstance]);

  return (
    <div className="slider-wrapper" style={{ position: "relative" }}>
      <div ref={ref} className="keen-slider">
        {(type === "channel" && title === "کانال ها"
          ? tenChannels
          : tenChannels
        )?.map((item, index) => (
          <div className="keen-slider__slide" key={index}>
            <Slide
              href={
                type === "channel"
                  ? `/single-channel/${item?.id}`
                  : `/video-page/${item?.id}/`
              }
              imgSrc={type === "channel" ? item.avatar : item.cover}
              label={type === "channel" ? item.name : item.title}
              views={
                type === "channel" ? item.counted_view : item.counted_views
              }
            />
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        className="custom-slick-btn custom-slick-prev"
        style={{ position: "absolute", left: "0", top: "40%", zIndex: 2 }}
        onClick={() => sliderInstance?.prev()}
      >
        <FontAwesomeIcon
          icon={faAngleLeft}
          mask={faCircle}
          transform="shrink-7"
        />
      </button>

      <button
        className="custom-slick-btn custom-slick-next"
        style={{ position: "absolute", right: "0", top: "40%", zIndex: 2 }}
        onClick={() => sliderInstance?.next()}
      >
        <FontAwesomeIcon
          icon={faAngleRight}
          mask={faCircle}
          transform="shrink-7"
        />
      </button>
    </div>
  );
}
